'use client';
import React from 'react';
import Map from './Map';

interface Location {
    name: string;
    coordinates: [number, number];
    state: string;
}

const locations: Location[] = [
    { name: "Los Angeles", state: "CA", coordinates: [34.0522, -118.2437] },
    { name: "Chicago", state: "IL", coordinates: [41.8781, -87.6298] },
    { name: "Savannah", state: "GA", coordinates: [32.0809, -81.0912] },
    { name: "New York City/NJ", state: "NY", coordinates: [40.7128, -74.0060] },
    { name: "Memphis", state: "TN", coordinates: [35.1495, -90.0490] },
    { name: "Dallas/Ft. Worth", state: "TX", coordinates: [32.7767, -96.7970] },
    { name: "Houston", state: "TX", coordinates: [29.7604, -95.3698] },
    { name: "Seattle/Tacoma", state: "WA", coordinates: [47.6062, -122.3321] },
    { name: "San Francisco/Oakland", state: "CA", coordinates: [37.7749, -122.4194] },
    { name: "Atlanta", state: "GA", coordinates: [33.7490, -84.3880] },
    { name: "Cincinnati", state: "OH", coordinates: [39.1031, -84.5120] },
    { name: "Cleveland", state: "OH", coordinates: [41.4993, -81.6944] },
    { name: "Columbus", state: "OH", coordinates: [39.9612, -82.9988] },
    { name: "Charleston", state: "SC", coordinates: [32.7765, -79.9311] },
    { name: "Salt Lake City", state: "UT", coordinates: [40.7608, -111.8910] },
    { name: "Denver", state: "CO", coordinates: [39.7392, -104.9903] },
    { name: "Wilmington", state: "DE", coordinates: [39.7447, -75.5484] },
    { name: "Jacksonville", state: "FL", coordinates: [30.3322, -81.6557] },
    { name: "Miami/Ft.Lauderdale", state: "FL", coordinates: [25.7617, -80.1918] },
    { name: "Tampa", state: "FL", coordinates: [27.9506, -82.4572] },
    { name: "Indianapolis", state: "IN", coordinates: [39.7684, -86.1581] },
    { name: "Louisville", state: "KY", coordinates: [38.2527, -85.7585] },
    { name: "New Orleans", state: "LA", coordinates: [29.9511, -90.0715] },
    { name: "Boston", state: "MA", coordinates: [42.3601, -71.0589] },
    { name: "Detroit", state: "MI", coordinates: [42.3314, -83.0458] },
    { name: "Minneapolis/St. Paul", state: "MN", coordinates: [44.9778, -93.2650] },
    { name: "Kansas City", state: "MO", coordinates: [39.0997, -94.5786] },
    { name: "Philadelphia", state: "PA", coordinates: [39.9526, -75.1652] },
    { name: "Norfolk", state: "VA", coordinates: [36.8508, -76.2859] },
    { name: "Birmingham", state: "AL", coordinates: [33.5186, -86.8104] },
    { name: "Huntsville", state: "AL", coordinates: [34.7304, -86.5861] },
    { name: "Baltimore", state: "MD", coordinates: [39.2904, -76.6122] },
    { name: "St. Louis", state: "MO", coordinates: [38.6270, -90.1994] },
    { name: "Charlotte", state: "NC", coordinates: [35.2271, -80.8431] },
    { name: "El Paso/Santa Teresa", state: "TX", coordinates: [31.7619, -106.4850] },
    { name: "Laredo", state: "TX", coordinates: [27.5306, -99.4803] }
];

const LocationMap: React.FC = () => {
    return (
        <section className="py-8">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-8">
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                        Our Nationwide Network
                    </h2>
                    <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
                        With strategic locations across the United States, we ensure efficient logistics 
                        and timely delivery for all your shipping needs.
                    </p>
                </div>
                <div>
                    <div className="w-full h-[600px] md:h-[600px] lg:h-[700px]">
                        <Map locations={locations} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocationMap; 